// extracted by mini-css-extract-plugin
module.exports = {"Cartagena":"Cartagena_Cartagena__1NlGn","Entrada":"Cartagena_Entrada__1js-a","Parrafo":"Cartagena_Parrafo__1STxB","Contenido":"Cartagena_Contenido__3nNXr"};